exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* START EVOQ COLOR PALETTE */\n/* END EVOQ COLOR PALETTE */\n/* START ATTENTION COLORS */\n/* END ATTENTION COLORS */\n/* SVG HOVER STATES */\nsvg {\n  fill: #C8C8C8;\n}\nsvg:hover {\n  fill: #6F7273;\n}\nsvg:active {\n  fill: #1E88C3;\n}\n/* END SVG HOVER STATES */\n._3oZpe0sXNMbh6iL5YggGy6 {\n  border-bottom: 1px solid #C8C8C8;\n}\n._3oZpe0sXNMbh6iL5YggGy6 > .dnn-grid-cell {\n  padding: 0 15px;\n}\n", ""]);

// Exports
exports.locals = {
	"extensionHeader": "_3oZpe0sXNMbh6iL5YggGy6"
};